import type { InventoryItem } from "./inventaireTypes";
import { Package, AlertTriangle, DollarSign, Star } from "lucide-react";
import { StatsCard } from "../StatsCard";

interface InventoryStatsProps {
  items: InventoryItem[];
  lowStockThreshold: number;
}

export function InventoryStats({ items, lowStockThreshold }: InventoryStatsProps) {
  // Calculate stats
  const totalValue = items.reduce((sum, item) => sum + item.prixVente * item.quantite, 0);
  const totalUnits = items.reduce((sum, item) => sum + item.quantite, 0);
  const totalItems = items.length;
  
  // Utiliser les seuils personnalisés pour le calcul du stock bas et rupture
  const lowStockCount = items.filter((item) => {
    const seuilStock = item.seuilStock ?? lowStockThreshold;
    const seuilRupture = item.seuilRupture ?? 0;
    return item.quantite > seuilRupture && item.quantite <= seuilStock && item.statut === "Actif";
  }).length;
  
  const outOfStockCount = items.filter((item) => {
    const seuilRupture = item.seuilRupture ?? 0;
    return item.quantite <= seuilRupture && item.statut === "Actif";
  }).length;
  
  const inCartCount = items.filter((item) => item.inCart).length;
  const inCartValue = items
    .filter((item) => item.inCart)
    .reduce((sum, item) => sum + item.prixCoutant * item.quantite, 0);

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 min-w-0">
      <StatsCard
        label="Valeur inventaire"
        value={`${totalValue.toFixed(2)}$`}
        description={`${totalUnits.toLocaleString()} unités`}
        icon={DollarSign}
        iconColor="var(--color-steel)"
        iconOffset="-36px"
      />

      <StatsCard
        label="Articles actifs"
        value={totalItems}
        description="En stock"
        icon={Package}
        iconColor="var(--color-olive)"
        descriptionColor="var(--color-olive)"
      />

      <StatsCard
        label="Stock bas / Rupture"
        value={`${lowStockCount} / ${outOfStockCount}`}
        description="Attention requise"
        icon={AlertTriangle}
        iconColor="var(--color-amber)"
        descriptionColor="var(--color-amber)"
      />

      <StatsCard
        label="Rappels"
        value={inCartCount}
        description={`Valeur: ${inCartValue.toFixed(2)}$`}
        icon={Star}
        iconColor="var(--color-steel)"
        descriptionColor="var(--color-steel)"
      />
    </div>
  );
}